import { WifiXIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import PageError from "./PageError";

export const NoNetworkConnectionPageError = () => {
  const intl = useIntl();

  return (
    <PageError
      title={intl.formatMessage({
        defaultMessage: "No Internet Connection",
        description: "noNetworkConnectionErrorTitle",
      })}
      subtitles={[
        intl.formatMessage({
          defaultMessage: "Check your connection and try again.",
          description: "noNetworkConnectionErrorSubtitle",
        }),
      ]}
      back={{
        text: intl.formatMessage({
          defaultMessage: "Back to home",
          description: "backToHome",
        }),
        options: { to: "/" },
      }}
      icon={<WifiXIcon size={60} color="#295942" />}
      hideWhatsAppButton
    />
  );
};
